import React from "react";

export default function TitleAndAuthors(props: any) {
  return (
    <>
      <div className="BookTitle">{props.bookInfo.title}</div>
      {props.bookInfo.subtitle && <div className="BookSubtitle">{props.bookInfo.subtitle}</div>}
      <div className="BookAuthorsContainer">
        {props.bookInfo.AuthorsInfos.map((authorInfo: { [key: string]: any }, index: number) => (
          <div className="BookAuthor" key={index}>
            {authorInfo.Name}
          </div>
        ))}
      </div>
    </>
  );
}
